import React from "react";
import ComponentTitle from "./ComponentTitle";
import { HogixxDropbox, PkcdxxDropbox, BsswghDropbox} from "./Dropbox";
import DropboxLabel from "./DropboxLabel";
import Button from "./Button";
import DateRangePicker from "./DateRangePicker";

const Search = ({searchRequestData, setSearchRequestData, handleSearch}) => {
  return (
    <div className="flex border-t border-b border-gray-400 py-2">
      <ComponentTitle title={"☞ 조회조건"}/>
      <div className="lg:flex md:grid-cols-2">
        <div className="flex mx-7 md:ml-1">
          <DropboxLabel searchCategory={"작업호기"} />
          <HogixxDropbox data={searchRequestData} setData={setSearchRequestData} />
        </div>
        <div className="mx-7 md:ml-1 font-bold flex items-center">
          <DropboxLabel searchCategory={"기간"} className="pr-2" />
          <DateRangePicker requestData={searchRequestData} setRequestData={setSearchRequestData} />
        </div>
        <div className="flex mx-7 md:ml-1">
          <DropboxLabel searchCategory={"지종"} />
          <PkcdxxDropbox data={searchRequestData} setData={setSearchRequestData}/>
        </div>
        <div className="flex mx-7 md:ml-1">
          <DropboxLabel searchCategory={"평량"} />
          <BsswghDropbox data={searchRequestData} setData={setSearchRequestData}/>
        </div>
        <Button buttonAction={handleSearch} buttonText={"조회(F7)"}/>
      </div>
    </div>
  )
}

export default Search;